import { useIsMobile } from '@bbl-digital/snorre-v2'
import { useAppDispatch, useAppSelector } from 'shared/store/store'
import { useHistory } from 'react-router'
import { useEffect, useRef } from 'react'
import {
  extraLargeBreakpoint,
  navigationBreakpoint,
} from 'shared/constants/styles'
import { toggleMenu } from 'shared/store/menu'
import { getMenuStates } from 'shared/store/menu/selectors'

const NO_SIDEBAR = '0px'
const SIDEBAR_WIDTH_OPEN = '250px'
const SIDEBAR_WIDTH_CLOSED = '72px'

const useMenuLayout = () => {
  const { push } = useHistory()
  const dispatch = useAppDispatch()
  const isMobile = useIsMobile(navigationBreakpoint)
  const isSmallSceen = useIsMobile(extraLargeBreakpoint)
  const { open, isManuallyToggled } = useAppSelector(getMenuStates)

  const isOpen = open && (!isSmallSceen || isManuallyToggled)
  const savedOpenState = useRef<boolean | null>(open)

  const goToHome = () => push('/')

  const handleOpen = (open: boolean) => {
    dispatch(toggleMenu(open))
  }

  const setMenuTemporarilyCollapsed = (collapsed: boolean) => {
    if (collapsed) {
      savedOpenState.current = open
      if (open) handleOpen(false)
      return
    }

    if (savedOpenState.current) {
      handleOpen(true)
    }
    savedOpenState.current = null
  }

  useEffect(() => {
    return () => {
      if (!savedOpenState.current) return

      dispatch(toggleMenu(true))
      savedOpenState.current = null
    }
  }, [])

  const getSideMenyWidth = () => {
    if (isMobile) return NO_SIDEBAR
    if (isOpen) return SIDEBAR_WIDTH_OPEN
    return SIDEBAR_WIDTH_CLOSED
  }

  return {
    getSideMenyWidth,
    handleOpen,
    setMenuTemporarilyCollapsed,
    goToHome,
    isOpen,
    isMobile,
  }
}

export default useMenuLayout
